var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#5E5E5E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_384_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7011 9.41966L8.52585 14.9142C7.95542 15.1701 7.76248 15.6825 8.38796 15.9606L12.0245 17.1223L20.8173 11.6601C21.2974 11.3172 21.7889 11.4086 21.3659 11.7858L13.8142 18.6588L13.5769 21.5674C13.7967 22.0165 14.199 22.0186 14.4556 21.7954L16.5449 19.8082L20.1232 22.5016C20.9543 22.9962 21.4065 22.677 21.5853 21.7705L23.9323 10.5996C24.176 9.48379 23.7605 8.99216 22.7011 9.41966Z",
    className: "fill",
    fill: "#EFEDEA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_384_60"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.c8cfe9f59ed433a903cd12f9471807b3.svg";
export { ForwardRef as ReactComponent };